// @file Network requests related to user from surface

import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { User as UserType, UserCamelCase, UserLibrarySettingsApiResponse } from '@@/types'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

class UserApi extends FetchableObject {
  public static async fetchuserLibrarySettings(): Promise<JsonAPIResponse<UserLibrarySettingsApiResponse>> {
    return await fetchJson('/api/1/dashboard_settings/user_library_settings', {
      method: HTTPMethod.get,
    })
  }

  public static async fetchSettingsUserInfo(fetchOptions = {}): Promise<JsonAPIResponse<UserCamelCase>> {
    return await fetchJson(`/api/1/dashboard_settings/user`, {
      method: HTTPMethod.get,
      ...fetchOptions,
    })
  }

  public static async updateSettingsUserInfo(fetchOptions = {}): Promise<JsonAPIResponse<UserType>> {
    return await fetchJson('/api/1/dashboard_settings/user', {
      method: HTTPMethod.patch,
      ...fetchOptions,
    })
  }
}

export { UserApi }
